export type MuxPlayerMetadataInput = {
	title?: string;
	description?: string;
	thumbnail?: string;
	viewerUserId?: string;
	videoId?: string;
	video_title?: string;
	video_id?: string;
	viewer_user_id?: string;
};

export type BuildMuxPlayerConfigInput = {
	playbackId: string;
	thumbnailUrl: string;
	metadata?: MuxPlayerMetadataInput | null;
	fullscreenElementId?: string;
	defaultDuration?: number;
};

export type MuxPlayerConfig = {
	playbackId: string;
	poster: string;
	streamType: "on-demand";
	preload: "metadata";
	fullscreenElement?: string;
	defaultDuration?: number;
	metadata: {
		video_id: string;
		video_title?: string;
		viewer_user_id?: string;
	};
};

/**
 * Build Mux Player props using playbackId (not a hand-built HLS src) and
 * Mux Data metadata keys so views are attributed correctly.
 *
 * @param input - Playback id, poster, optional metadata / fullscreen host
 * @returns Props safe to spread onto MuxPlayer
 */
export const buildMuxPlayerConfig = (
	input: BuildMuxPlayerConfigInput,
): MuxPlayerConfig => {
	const meta = input.metadata ?? {};
	const videoTitle = meta.video_title ?? meta.title;
	const videoId = meta.video_id ?? meta.videoId ?? input.playbackId;
	const viewerUserId = meta.viewer_user_id ?? meta.viewerUserId;

	const config: MuxPlayerConfig = {
		playbackId: input.playbackId,
		poster: input.thumbnailUrl,
		streamType: "on-demand",
		preload: "metadata",
		metadata: {
			video_id: videoId,
			...(videoTitle ? { video_title: videoTitle } : {}),
			...(viewerUserId ? { viewer_user_id: viewerUserId } : {}),
		},
	};

	if (input.fullscreenElementId) {
		config.fullscreenElement = input.fullscreenElementId;
	}

	if (input.defaultDuration != null) {
		config.defaultDuration = input.defaultDuration;
	}

	return config;
};
